import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay, EffectFade } from 'swiper/modules';

window.addEventListener('DOMContentLoaded', () => {
	const option = {
		modules: [Navigation, Pagination],
		loop: false,
		speed: 800,
		slidesPerView: 1.35,
		spaceBetween: 20,
		pagination: {
			el: ".swiper-sp_only-pagination",
			clickable: true,
		},
		breakpoints: {
			768: {
				slidesPerView: 2.5,
			},
		},
		navigation: {
			nextEl: ".swiper-sp_only-button-next",
			prevEl: ".swiper-sp_only-button-prev"
		}
	}
	const breakPoint = 768;
	let swiper;
	if ( window.innerWidth <= breakPoint ) {
		swiper = new Swiper('.js-swiper-sp_only', option);

	} else {
		swiper = undefined;
	}
	window.addEventListener('resize', () => {
		if ( window.innerWidth <= breakPoint ) {
			if( swiper ) return;
			swiper = new Swiper('.js-swiper-sp_only', option);
		} else {
			if( !swiper ) return;
			swiper.destroy();
			swiper = undefined;
		}
	}, false);
}, false);


// MV
const homeMVSwiper = () => {
	const homeMV = new Swiper(".js-swiper-home-mv", {
		modules: [Autoplay, EffectFade],
		effect: 'fade',
		fadeEffect: {
			crossFade: true,
		},
		loop: true,
		initialSlide : 0,
		speed: 3000,
		autoplay: {
			delay: 4000,
			pauseOnMouseEnter: false,
			disableOnInteraction: false,
			waitForTransition: false,
			reverseDirection: false,
		}
	});
};
window.addEventListener('load', function(){
	homeMVSwiper();
});
